import "./ContactModal.css";

export default function ContactModal({ onClose }) {
  return (
    <div className="modal-backdrop" onClick={onClose}>
      <div className="modal" onClick={(e) => e.stopPropagation()}>
        <h2>Kontakt aufnehmen</h2>

        <form className="contact-form">
          <input type="text" placeholder="Ihr Name" required />
          <input type="email" placeholder="Ihre E-Mail" required />
          <textarea placeholder="Ihre Nachricht" rows="4" required />
          <button type="submit">Nachricht senden</button>
        </form>

        <button className="close-btn" onClick={onClose}>✕</button>
      </div>
    </div>
  );
}
